import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Weardeck Experts`('0.0.1')({
  gutterless: true,
  view: () => <UI.Modules.Page.Reusable value={ {path: 'composites', name: 'Weardeck Experts' } } />,
  edit: {}
});
